import { render } from "./PasswordHealthChecker.vue?vue&type=template&id=5375b788&scoped=true"
import script from "./PasswordHealthChecker.vue?vue&type=script&lang=js"
export * from "./PasswordHealthChecker.vue?vue&type=script&lang=js"

import "./PasswordHealthChecker.vue?vue&type=style&index=0&id=5375b788&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5375b788"]])

export default __exports__